// The point until which the number of seconds will be shown.
export const SECONDS_THRESHOLD = 60000;
